import PropTypes from 'prop-types';

import css from 'styles/components/account/orderCareBillingAddressCard.scss';

const OrderCareBillingAddressCard = ({ address, onSelectBillingAddress, inputId, inputName, isRequired, currentAddress }, { testId }) => {
  const {
    addressId,
    name,
    mailingAddress: {
      addressLine1,
      addressLine2,
      city,
      stateOrRegion,
      countryName,
      postalCode
    }
  } = address;

  const makeSuggestedAddressHighlight = field => {
    if (currentAddress && address.mailingAddress[field]?.toLowerCase() !== currentAddress[field]?.toLowerCase()) {
      return css.highlight;
    }
  };

  return (
    <div className={css.wrap}>
      <div className={css.innerWrap}> {/* for spacing between cards */}
        <input
          id={inputId || addressId}
          className={css.selectBillingRadioBtn}
          type="radio"
          onChange={onSelectBillingAddress}
          name={inputName || 'billingAddress'}
          required={isRequired}
          data-test-id={testId('billingAddressCard')} />
        <label htmlFor={inputId || addressId}>
          <span className={css.customerInfo}>
            {name?.fullName && (<span>{name.fullName}</span>)} {/* not present in suggested address */}
            <span className={makeSuggestedAddressHighlight('addressLine1')}>{addressLine1}</span>
            {addressLine2 && (<span className={makeSuggestedAddressHighlight('addressLine2')}>{addressLine2}</span>)}
            <span className={css.cityStatePostal}>
              <span className={makeSuggestedAddressHighlight('city')}>{city},</span>
              <span className={makeSuggestedAddressHighlight('stateOrRegion')}> {stateOrRegion}</span>
              <span className={makeSuggestedAddressHighlight('postalCode')}> {postalCode}</span>
            </span>
            <span>{countryName}</span>
          </span>
        </label>
      </div>
    </div>
  );
};

OrderCareBillingAddressCard.contextTypes = {
  testId: PropTypes.func
};

export default OrderCareBillingAddressCard;
